import cc from 'classcat'
import React from 'react'

import { reactClass } from '../../../utils'
import * as Styled from './styles'

type StackDirection = 'horizontal' | 'vertical'

export type StackLayoutProps = {
  children?: React.ReactNode
  className?: string
  direction?: StackDirection
}

export type StackLayoutBoxProps = {
  children?: React.ReactNode
}

export const StackLayoutBox = ({ children, ...rest }: StackLayoutBoxProps) => {
  return <div {...rest}>{children}</div>
}

export const StackLayout = ({ children, className, direction = 'horizontal' }: StackLayoutProps) => {
  const flexDirection = direction === 'horizontal' ? 'row' : 'column'

  return (
    <Styled.StackLayoutResponsiveWrapper
      className={cc([className, reactClass('stack-layout')])}
      direction={flexDirection}
    >
      {children}
    </Styled.StackLayoutResponsiveWrapper>
  )
}
